import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=26d0c67e&scoped=true"
import script from "./Album.vue?vue&type=script&lang=js"
export * from "./Album.vue?vue&type=script&lang=js"
import style0 from "./Album.vue?vue&type=style&index=0&id=26d0c67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d0c67e",
  null
  
)

export default component.exports